import React from 'react';
import PropTypes from 'prop-types';

import Tag from './Tag';

import './styles.css';

function TagList({ tagData, ...props }) {
  return (
    <ul className="AdminTableTagList" {...props}>
      {tagData.map((tag, i) => (
        <Tag
          key={i}
          text={tag.name}
          highlight={tag.name === 'Administrator'}
        />
        ))}
    </ul>
  );
}

TagList.propTypes = {
  tagData: PropTypes.array.isRequired,
};

export default TagList;
